import { splitMemberFullName } from '../api/membersDirectory';

/**
 * @param {string | null | undefined} iso
 */
export function isoToDateInputValue(iso) {
    if (!iso || typeof iso !== 'string') return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}

/**
 * @param {string} dateStr
 */
export function dateInputToIso(dateStr) {
    if (!dateStr.trim()) return '';
    return new Date(`${dateStr}T12:00:00`).toISOString();
}

/**
 * @param {{
 *   fullName?: string;
 *   firstName?: string;
 *   lastName?: string;
 *   phoneNumber?: string;
 *   email?: string;
 *   jobTitle?: string;
 *   company?: string;
 *   sector?: string;
 *   university?: string | null;
 *   highSchool?: string | null;
 *   address?: string;
 *   workAddress?: string;
 *   tcKimlikNo?: string;
 *   birthDate?: string | null;
 *   clubJoinDate?: string | null;
 *   website?: string | null;
 *   hobbies?: string | null;
 *   facebook?: string | null;
 *   twitter?: string | null;
 *   linkedIn?: string | null;
 * }} record
 */
export function memberRecordToProfileFormState(record) {
    let firstName = String(record.firstName || '').trim();
    let lastName = String(record.lastName || '').trim();
    if (!firstName && !lastName) {
        const split = splitMemberFullName(record.fullName || '');
        firstName = split.givenName;
        lastName = split.familyName;
    }

    return {
        firstName,
        lastName,
        phoneNumber: String(record.phoneNumber || ''),
        email: String(record.email || ''),
        jobTitle: String(record.jobTitle || ''),
        company: String(record.company || ''),
        sector: String(record.sector || ''),
        university: String(record.university || ''),
        highSchool: String(record.highSchool || ''),
        address: String(record.address || ''),
        workAddress: String(record.workAddress || ''),
        tcKimlikNo: String(record.tcKimlikNo || ''),
        birthDate: isoToDateInputValue(record.birthDate),
        clubJoinDate: isoToDateInputValue(record.clubJoinDate),
        website: String(record.website || ''),
        hobbies: String(record.hobbies || ''),
        facebook: String(record.facebook || ''),
        twitter: String(record.twitter || ''),
        linkedIn: String(record.linkedIn || ''),
    };
}

/**
 * @param {ReturnType<typeof memberRecordToProfileFormState>} form
 */
export function profileFormStateToUpdatePayload(form) {
    const firstName = form.firstName.trim();
    const lastName = form.lastName.trim();

    return {
        firstName,
        lastName,
        phoneNumber: form.phoneNumber.trim(),
        email: form.email.trim(),
        jobTitle: form.jobTitle.trim(),
        company: form.company.trim(),
        sector: form.sector.trim(),
        university: form.university.trim(),
        highSchool: form.highSchool.trim(),
        address: form.address.trim(),
        tcKimlikNo: form.tcKimlikNo.trim(),
        birthDate: dateInputToIso(form.birthDate),
        workAddress: form.workAddress.trim(),
        clubJoinDate: dateInputToIso(form.clubJoinDate),
        website: form.website.trim(),
        hobbies: form.hobbies.trim(),
        facebook: form.facebook.trim(),
        twitter: form.twitter.trim(),
        linkedIn: form.linkedIn.trim(),
    };
}
